import TabbedDialog from 'global/guides/Dialog/TabbedDialog'
import { useAuth } from 'hooks'
import { hasPermission } from 'hooks/useBackendMenu'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import {
    avaliacao,
    AvaliacaoSchema,
    clientes,
    CreateAvaliacaoSchema,
} from 'service/api'
import { toast } from 'sonner'
import { match } from 'ts-pattern'
import { NovoClienteForm } from '../forms/NovoCliente'
import PlanoDiferenciado from './PlanoDiferenciado'

export default function AdicionarClienteMenuItem() {
    const navigate = useNavigate()
    const [categoriaId, setCategoriaId] = useState(0)
    const toggle = () => navigate('/administracao/clientes')
    const { mutateAsync, isLoading } = avaliacao.mutations.useCreate({
        onSuccess: async () => {
            const tipo = match(categoriaId)
                .with(6, () => 'Avaliação')
                .with(3, () => 'Cliente')
                .otherwise(() => 'Representante')

            toast.success(`${tipo} criado(a) com sucesso!`)
            await clientes.invalidateQueries()
        },
        onError: err => {
            toast.error(err.message)
        },
    })
    const {
        decoded: { sub },
    } = useAuth()

    return (
        <TabbedDialog.Root
            open={hasPermission(['create', 'Clientes'])}
            onClose={toggle}
            width="42rem"
            loading={isLoading}
            onSubmit={values => mutateAsync(values)}
            schema={getShemaValidation(categoriaId)}
            onChange={values => setCategoriaId(values.categoriaId)}
            defaultValues={{
                PlanoDiferenciado: {
                    editar: true,
                    periodicidade: 'monthly',
                },
                categoriaId: 3,
                criadorId: sub,
            }}
            tabs={[
                {
                    name: 'dados',
                    label: 'Dados do cliente',
                    content: <NovoClienteForm />,
                },
                ...([3, 6].includes(categoriaId)
                    ? [
                          {
                              name: 'plano',
                              label: 'Plano diferenciado',
                              content: <PlanoDiferenciado />,
                          },
                      ]
                    : []),
            ]}
        >
            <TabbedDialog.Title>Criar cliente</TabbedDialog.Title>
            <TabbedDialog.Content dividers />
            <TabbedDialog.Actions>
                <TabbedDialog.Actions.SecondaryButton />
                <TabbedDialog.Actions.PrimaryButton closeOnSubmit />
            </TabbedDialog.Actions>
        </TabbedDialog.Root>
    )
}

function getShemaValidation(categoriaId = 3) {
    if (categoriaId === 7) {
        return AvaliacaoSchema.pick({
            emailResponsavel: true,
            nomeResponsavel: true,
            telefone: true,
            senha: true,
            categoriaId: true,
            criadorId: true,
            confirme: true,
        }).refine(data => data.senha === data.confirme, {
            message: 'As senhas não conferem',
            path: ['confirme'],
        })
    }

    return CreateAvaliacaoSchema
}
